import React, { useContext } from 'react'
import Heading from '@react/react-spectrum/Heading'
import Link from '../Nav/Link'
import BackButton from '../Nav/BackButton'
import Title from '../Nav/Title'
import Switch from '../Nav/Switch'
import { __ } from 'i18n-for-browser'
import '../../config/i18n'
import useMultilineText from '../hooks/useMultilineText'
import { EasybakeContext } from '../EasybakeProvider'

export default function NavPsActions () {
    const { page } = useContext(EasybakeContext)
    const summary = useMultilineText(__('psactions_nav_summary'))
    const instruction = useMultilineText(__('psactions_nav_instruction'))

    return (
        <div className="adobe-easybake-nav feature">
            <BackButton className="adobe-easybake-nav-back-button"/>
            <div className="adobe-easybake-nav-content">
                <Title title={__('psactions_nav_title')} />
                <div className="summary">
                    {summary}
                </div>
                <div className="adobe-easybake-nav-links">
                    <Link className="adobe-easybake-nav-link" referrer={`demovideo:${page}:nav`} label={__('link_demo_video')} url={__('url_demo_video_psactions')} />
                    <div className="adobe-easybake-nav-links-between" />
                    <Link className="adobe-easybake-nav-link" referrer={`documentation:${page}:nav`} label={__('link_doc')} url={__('url_doc_psactions')} />
                </div>
                <div>
                    {instruction}
                </div>
                <div className="adobe-easybake-nav-actions">
                    <Heading variant="subtitle2">
                        <Switch group="psactions" label={__('psactions_nav_apply_bannergeneration')} action="bannergeneration" position="labelLeft" />
                        <Switch group="psactions" label={__('psactions_nav_apply_camerarawfilter')} action="camerarawfilter" position="labelLeft" />
                        <Switch group="psactions" label={__('psactions_nav_apply_graphicdesign')} action="graphicdesign" position="labelLeft" />
                        <hr className="adobe-easybake-hr-dark" />
                        <Switch group="psactions" label={__('psactions_nav_apply_custom')} action="psactionscustom" position="labelLeft" />
                    </Heading>
                </div>
            </div>
        </div>
    )
}
